module.exports = __webpack_public_path__ + "static/media/jackpot-highlight.da29538f.png";